import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateTariffComponent } from './create-tariff.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    CreateTariffComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports:[
    CreateTariffComponent
  ]
})
export class CreateTariffModule { }
